module.exports = __webpack_public_path__ + "static/people_img23-1dcf25657671a82479e60c7ea85e6d3a.png";